import React from "react";
import { Shield, Crown, Edit3, Eye, User } from "lucide-react";

export default function PermissionBadge({ type, level }) {
  const getConfig = () => {
    if (type === "global") {
      switch (level) {
        case "creator":
          return {
            icon: Crown,
            label: "Creator",
            color: "bg-gradient-to-r from-amber-500 to-orange-500 text-white",
            borderColor: "border-amber-300",
          };
        case "non_creator":
        default:
          return {
            icon: User,
            label: "Non-Creator",
            color: "bg-gray-100 text-gray-700",
            borderColor: "border-gray-300",
          };
      }
    } else {
      // Table permissions
      switch (level) {
        case "owner":
          return {
            icon: Crown,
            label: "소유자",
            color: "bg-gradient-to-r from-blue-600 to-blue-700 text-white",
            borderColor: "border-blue-300",
          };
        case "admin":
          return {
            icon: Shield,
            label: "관리자",
            color: "bg-gradient-to-r from-purple-600 to-purple-700 text-white",
            borderColor: "border-purple-300",
          };
        case "edit":
          return {
            icon: Edit3,
            label: "편집자",
            color: "bg-gradient-to-r from-green-600 to-green-700 text-white",
            borderColor: "border-green-300",
          };
        case "view":
          return {
            icon: Eye,
            label: "조회자",
            color: "bg-gray-100 text-gray-700",
            borderColor: "border-gray-300",
          };
        default:
          return {
            icon: User,
            label: "권한 없음",
            color: "bg-gray-50 text-gray-500",
            borderColor: "border-gray-200",
          };
      }
    }
  };

  const config = getConfig();
  const Icon = config.icon;

  return (
    <div
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${config.color} border ${config.borderColor}`}
    >
      <Icon className="w-3.5 h-3.5" />
      <span>{config.label}</span>
    </div>
  );
}
